import {http_client} from '@/plugins/http_client';
const listarEmpleados = async (body) => await http_client(`/api/v1/reporte-planilla/obtener-planilla-empleado`, body, 'get');
const catalogoObservaciones = async () => await http_client(`/api/v1/reporte-planilla/obtener-codigo-observacion`, {}, 'get');
const catalogoTipoDocumento = async () => await http_client(`/api/v1/reporte-planilla/obtener-tipo-documento`, {}, 'get');
const catalogoIngresosVacacion = async (id) => await http_client(`/api/v1/reporte-planilla/obtener-ingresos-vacacion/${id}`, {}, 'get');
const catalogoInstitucion = async () => await http_client(`/api/v1/reporte-planilla/obtener-institucion-previsional`, {}, 'get');
const descargarCSV = async (params) => await http_client(`/api/v1/reporte-planilla/reporte-planilla-unica`, params, 'get');
const descargarXLSX = async (params) => await http_client(`/api/v1/reporte-planilla/reporte-planilla-unica-xlsx`, params, 'get');
export default {
    listarEmpleados,
    catalogoObservaciones,
    catalogoTipoDocumento,
    catalogoIngresosVacacion,
    catalogoInstitucion,
    descargarCSV,
    descargarXLSX
}
